import React, { Component } from 'react'
import { withStyles } from '@material-ui/core'

import Spinner from 'spinner'
import PDCButton from 'pdc-button'
import ConfirmModal from 'confirm-modal'
import ConfirmDeleteModal from 'confirm-delete-modal'
import { MeetingsDefaultArrowTooltip, ErrorArrowTooltip } from 'tooltips'
import HelpIcon from '@material-ui/icons/Help'
import FormControl from '@material-ui/core/es/FormControl/FormControl'
import InputLabel from '@material-ui/core/es/InputLabel/InputLabel'
import TextField from '@material-ui/core/es/TextField/TextField'
import FormHelperText from '@material-ui/core/es/FormHelperText/FormHelperText'
import Snackbar from '@material-ui/core/Snackbar'
import Slide from '@material-ui/core/Slide'
import Select from '@material-ui/core/es/Select/Select'
import MenuItem from '@material-ui/core/es/MenuItem/MenuItem'
import Popper from '@material-ui/core/Popper'

import { InfoTipIcon, LaunchIcon, MeetingsMessageIcon, DeleteIcon, CheckmarkIcon } from 'pdc-svg-icons'

import API from '../util/api_v5'

const styles = theme => ({
	urlFieldsWrapper: {
		display:	'flex',
		alignItems:	'baseline'
	},
	urlStyle: {
		display:		'flex',
		alignItems:		'center',
		paddingTop:		20,
		paddingBottom:	4,
		fontSize:		16
	},
	inputLabel: {
		color:			'black',
		textTransform:	'uppercase',
		display:		'flex',
		alignItems:		'center',
		'& svg': {
			marginLeft:	5
		}
	},
	urlInputLabel: {
		transformOrigin:	'right',
		right:				0,
		left:				'unset'
	},
	selectPlaceholder: {
		position:	'absolute',
		top:		20,
		left:		0,
		fontSize:	16,
		color:		'#88969e'
	},
	planPopperWrapper: {
		fontFamily:		'Montserrat, Helvetica, arial, sans-serif !important',
		width:			577,
		borderRadius:	5,
		overflowY:		'hidden',
		background:		'white',
		boxShadow:		'0 16px 16px 0 rgba(0, 0, 0, 0.15), 0 0 24px 0 rgba(0, 0, 0, 0.22)'
	},
	planPopperArrow: {
		position:		'absolute',
		left:			'50%',
		top:			-10,
		transform:		'translateX(-50%)',
		borderLeft:		'10px solid transparent',
		borderRight:	'10px solid transparent',
		borderBottom:	'10px solid white'
	},
	planMainSection: {
		display:		'flex',
		justifyContent:	'space-between',
		padding:		'30px 30px 10px'
	},
	planItem: {
		'&:not(:last-child)': {
			marginRight: 24
		}
	},
	planName: {
		color:			theme.meetingsAdminApp.planMainItemsColor,
		fontSize:		22,
		lineHeight: 	1.27,
		letterSpacing:	-0.1,
		marginBottom:	5
	},
	planInfo: {
		color:			'black',
		lineHeight:		1.1,
		letterSpacing:	-0.1,
		fontSize:		20,
		fontWeight:		500,
		marginBottom:	3,
		fontFamily:		'NTR, Montserrat, Helvetica, arial, sans-serif !important'
	},
	planPromo: {
		color:		theme.meetingsAdminApp.planPromoColor,
		fontSize:	14,
		fontWeight:	'bold',
		fontStyle:	'italic'
	},
	planDescription: {
		color:			'black',
		fontSize:		14,
		lineHeight:		1.36,
		marginBottom:	8
	},
	planHipaa: {
		color:		theme.meetingsAdminApp.planHipaaColor,
		lineHeight:	1.33,
		fontSize:	12,
		fontWeight:	600
	},
	planSeparator: {
		borderTop:	`1px solid ${theme.meetingsAdminApp.separatorColor}`,
		margin:		'0 10px'
	},
	planFooter: {
		display:		'flex',
		justifyContent:	'flex-end',
		padding:		10,
		'& > a': {
			color:		theme.palette.primary.main,
			fontSize:	12,
			fontWeight:	600,
			lineHeight:	1.33,
			'& svg': {
				marginLeft:	6,
				width:		20
			}
		}
	},
	infoIcon: {
		cursor:	'pointer'
	},
	basePlanInfo: {
		marginTop: 25,
		'& > a': {
			color:		theme.palette.primary.main,
			display:	'inlineFlex',
			alignItems:	'center',
			'& svg': {
				marginLeft:	6,
				width:		20
			}
		},
		'& b': {
			fontWeight: 'bold'
		}
	},
	userStyle: {
		width:			280,
		float:			'left',
		textAlign:		'left',
		overflowX:		'scroll',
		display:		'flex',
		flexDirection:	'column',
		'&::-webkit-scrollbar': {
			display: 'none'
		},
		'& .user-name': {
			fontSize:	16,
		},
		'& .user-email': {
			fontSize:	13
		}
	},
	extStyle: {
		width: 280,
		float: 'left',
		textAlign: 'left',
		overflowX: 'scroll',
		'&::-webkit-scrollbar': {
			display: 'none'
		}
	},
	hostStyle: {
		width:		255,
		float:		'left',
		textAlign:	'left'
	},
	actionsStyle: {
		paddingLeft:	15,
		width:			50,
		float:			'left',
		textAlign:		'left',
		display:		'flex',
		justifyContent:	'space-between'
	},
	actionIconStyle:{
		width:	50,
		height:	34,
		cursor:	'pointer',
		'&:not(:last-child)': {
			marginRight: 20
		}
	},
	actionButton: {
		width:	170,
		height:	40,
		cursor:	'pointer'
	},
	responseErrorMessage: {
		margin:				'50px 0',
		padding:			'15px 43px',
		fontSize:			14,
		fontWeight:			'bold',
		lineHeight:			1.36,
		borderRadius:		25,
		textAlign:			'center',
		border:				'solid 1px var(--brand-green-tint-2)',
		backgroundColor:	theme.meetingsAdminApp.uesrsLimitMessageBackgroundColor,
		color:				theme.meetingsAdminApp.usersLimitMessageColor
	},
	planSelectStyle: {
		marginRight: 15,
		width: 100
	},
	selectedCheckmark: {
		width:		18,
		position:	'absolute',
		right:		10
	},
	tableHeaderRow: {
		borderBottom:		'1px solid',
		borderBottomColor:	theme.meetingsAdminApp.separatorColor,
		display:			'flex'
	},
	tableHeaderStyle: {
		fontSize:	16,
		fontWeight:	'bold',
		lineHeight:	1.38,
		padding:	'13px 0'
	},
	spinnerStyle: {
		paddingTop: 20,
		margin: 'auto',
		width: 100
	},
	headerStyle: {
		fontWeight: 700,
		paddingTop:30
	},
	fieldsWrapper: {
		display:		'flex',
		justifyContent:	'space-between',
		'& p.Mui-error': {
			color:		theme.meetingsAdminApp.errorColor,
			fontWeight:	600
		}
	},
	header: {
		height:			34,
		fontSize:		30,
		fontWeight:		600,
		lineHeight:		1.13,
		letterSpacing:	-0.3,
		marginBottom:	16
	},
	helpIcon: {
		color:		theme.palette.primary.main,
		cursor:		'pointer',
		marginLeft:	10
	},
	section: {
		marginBottom: 50
	},
	sectionHeader: {
		backgroundColor:	theme.meetingsAdminApp.sectionHeaderBackgroundColor,
		marginBottom:		25,
		fontSize:			16,
		fontWeight:			'bold',
		lineHeight:			1.25,
		padding:			15,
		display:			'flex',
		alignItems:			'center',
		textTransform:		'uppercase'
	},
	rowStyle: {
		height:				35,
		borderBottom:		'1px solid',
		borderBottomColor:	theme.meetingsAdminApp.separatorLightColor,
		display:			'flex',
		alignItems:			'center',
		boxSizing:			'content-box',
		padding:			'10px 0'
	},
	cellStyle: {
		fontSize: 16
	},
	textFieldNoValue: {
		'& .MuiInput-input': {
			color: theme.meetingsAdminApp.placeholderColor
		}
	},
	textFieldErrorRight: {
		'& .Mui-error': {
			textAlign: 'right'
		}
	},
	dropdownList: {
		backgroundImage:	`linear-gradient(to bottom, white, ${theme.meetingsAdminApp.dropdownDarkColor} 25%)`,
		minWidth:			100,
		'& li': {
			'&:hover': {
				backgroundColor: `${theme.meetingsAdminApp.dropdownItemHoverBackgroundColor} !important`
			},
			'&.Mui-selected': {
				'background': 'initial'
			}
		}
	},
	planPopper: {
		zIndex: 10
	},
	snackbarWrapper: {
		bottom: 196
	},
	snackbarDiv: {
		backgroundColor:	theme.meetingsAdminApp.snackbarBackgroundColor,
		padding:			'15px 30px',
		width:				415,
		borderRadius:		5
	},
	snackbarMessage: {
		fontSize:	14,
		fontWeight:	600,
		lineHeight:	1.36,
		padding:	0
	},
	cancelServiceModalContent: {
		fontFamily: 'Montserrat, Helvetica, arial, sans-serif !important',
		'& > div': {
			marginBottom: 25,
			'&.please-message': {
				marginBottom:	10,
				fontWeight:		600
			}
		},
		'& textarea': {
			background:		'#f5f5f5',
			borderRadius:	5,
			height:			75,
			width:			'100%',
			padding:		'5px 10px',
			resize:			'none',
			outline:		'none'
		}
	},
	processingActionSpinnerWrapper: {
		display:		'flex',
		justifyContent:	'center',
		alignItems:		'center',
		background:		'rgba(255, 255, 255, 0.4)',
		position:		'absolute',
		left:			0,
		right:			0,
		top:			0,
		bottom:			0,
		zIndex:			2000,
		'& svg': {
			fontSize:	50
		}
	}
})

class AddUsers extends Component {

	state = {
		name:								'',
		email:								'',
		extension:							'',
		plans:								[],
		emailErrorText:						'',
		nameErrorText:						'',
		extensionErrorText:					'',
		responseError:						'',
		planErrorText:						'',
		snackBarOpen:						false,
		isConfirmDeleteHostModalShown:		false,
		planInfoHover:						false,
		planPopperHover:					false,
		planSelectOpened:					false,
		extensionsSelectOpened:				false,
		isSaveCompanySettingsModalShown:	false,
		isCancelServiceModalShown:			false,
		processingAction:					false
	}

	renderAddUsersTitle = () => {
		const { classes } = this.props
		let helpIcon = (
			<HelpIcon
				className	= {classes.helpIcon}
				onClick		= {() => window.open('https://www.phone.com/features/video-conferencing-service/')}
			/>
		)
		return (
			<div><h1 className={classes.header}>
				Configure Meetings {helpIcon}
			</h1></div>
		)
	}

	togglePlanInfoHover = planInfoHover => {
		if (planInfoHover) this.setState({planInfoHover})
		else setTimeout(() => this.setState({planInfoHover}), 100)
	}
	togglePlanPopperHover = planPopperHover => this.setState({planPopperHover})

	handleDomainEntryChange = event => this.props.changeDomainEntry(event.target.value)

	handleBusinessNameEntryChange = event => {
		this.props.updateBusinessNameEntry(event.target.value)
	}

	renderCompanySettings = () => {
		const { classes } = this.props
		return (
			<div className={classes.section}>
				<div className={classes.sectionHeader}>Company Settings</div>
				<div className={classes.fieldsWrapper}>
					<TextField
						disabled		= {this.props.addingUser}
						label			= 'Business Name'
						value			= {this.props.businessNameEntry}
						placeholder		= 'Your company name'
						onChange		= {this.handleBusinessNameEntryChange}
						InputLabelProps	= {{className: classes.inputLabel, shrink: true}}
						style			= {{width: 250}}
						error			= {Boolean(this.state.businessNameStateErrorText)}
						helperText		= {this.state.businessNameStateErrorText}
						className		= {!this.props.businessNameEntry ? classes.textFieldNoValue : null}
					/>
					<div className={classes.urlFieldsWrapper}>	
						<TextField
							style	= {{width: 150}}
							label	= {
								<span className={classes.inputLabel}>
									<span>Meeting Url</span>
									<MeetingsDefaultArrowTooltip
										title		= 'This is the URL you will share with your customers, so they can join your meeting. Tip: keep it short.'
										placement	= 'top'
									>
										<div><InfoTipIcon className={classes.infoIcon}/></div>
									</MeetingsDefaultArrowTooltip>
								</span>
							}
							onChange		= {this.handleDomainEntryChange}
							value			= {this.props.domainEntry}
							placeholder		='your-company-name'
							disabled		= {this.props.addingUser}
							error			= {Boolean(this.state.domainStateErrorText)}
							helperText		= {this.state.domainStateErrorText}
							className		= {`${classes.textFieldErrorRight} ${!this.props.domainEntry ? classes.textFieldNoValue : ''}`}
							inputProps		= {{style: {textAlign: 'right'}}}
							InputLabelProps	= {{className: `${classes.urlInputLabel} ${classes.inputLabel}`, shrink: true}}
						/>
						<span className={classes.urlStyle}>.meet.phone.com</span>
					</div>
					<FormControl error={Boolean(this.state.planErrorText)}>
						{!this.props.plan ? <div className={classes.selectPlaceholder}>Plan</div> : null}
						<InputLabel shrink={true} id='demo-simple-select-label' className={classes.inputLabel}>
							<span>Plan </span>
							<Popper
								open		= {this.state.planInfoHover || this.state.planPopperHover}
								anchorEl	= {document.getElementById('plan-info')}
								className	= {classes.planPopper}
								placement	= 'bottom'
							>
								{this.renderMeetingsPricingInfo()}
							</Popper>
							<div id='plan-info'
								onMouseEnter={() => this.togglePlanInfoHover(true)}
								onMouseLeave={() => this.togglePlanInfoHover(false)}
							>
								<InfoTipIcon className={classes.infoIcon}/>
							</div>
						</InputLabel>
						{this.renderPlans()}
						<FormHelperText>{this.state.planErrorText}</FormHelperText>
					</FormControl>

					<PDCButton
						variant		= 'new-primary'
						onClick		= {this.onSaveSettingsClick}
						disabled	= {this.props.addingUser || !this.props.domainEntry || !this.props.businessNameEntry}
						className	= {classes.actionButton}
					>{this.props.isMeetingsEnabled ? 'Save settings' : 'Activate'}</PDCButton>
				</div>
				<div className={classes.basePlanInfo}>
					<a href='https://www.phone.com/features/video-conferencing-service/' target='_blank'><b>View all plans</b><LaunchIcon/></a>
				</div>
			</div>
		)
	}

	renderMeetingsPricingInfo = () => {
		const { classes } = this.props
		return (
			<div
				className		= {classes.planPopperWrapper}
				onMouseEnter	= {() => this.togglePlanPopperHover(true)}
				onMouseLeave	= {() => this.togglePlanPopperHover(false)}
			>
				<div className={classes.planPopperArrow}></div>
				<div className={classes.planMainSection}>
					<div className={classes.planItem}>
						<div className={classes.planName}>Base Plan</div>
						<div className={classes.planInfo}>$4.99/mo per host</div>
					</div>
					<div className={classes.planItem}>
						<div className={classes.planName}>Plus Plan</div>
						<div className={classes.planInfo}>$9.99/mo per host</div>
						<div className={classes.planDescription}>Includes Call Recording<br/>and Password Protection</div>
						<div className={classes.planHipaa}>HIPAA compliant</div>
					</div>
					<div className={classes.planItem}>
						<div className={classes.planName}>Pro Plan</div>
						<div className={classes.planInfo}>$14.99/mo per host</div>
						<div className={classes.planDescription}>Includes Call Transcription</div>
						<div className={classes.planHipaa}>HIPAA compliant</div>
					</div>
				</div>
				<hr className={classes.planSeparator}/>
				<div className={classes.planFooter}>
					<a href='https://www.phone.com/features/video-conferencing-service/' target='_blank'><b>View full details</b><LaunchIcon/></a>
				</div>
			</div>
		)
	}
	
	renderPlans = () => {
		const { classes } = this.props
		const plans = [{ name: 'Base', code: 'MEETINGS_BASE' }, { name: 'Plus', code: 'MEETINGS_PLUS' }, { name: 'Pro', code: 'MEETINGS_PRO' }]
		const className = classes.planSelectStyle
		return (
			<Select
				value		= {this.props.plan}
				onChange	= {this.onPlanChange}
				disabled	= {this.props.addingUser}
				MenuProps	= {{
					classes: {list: classes.dropdownList},
					anchorOrigin: {
						vertical: 'bottom',
						horizontal: 'center'
					},
					transformOrigin: {
						vertical: 'top',
						horizontal: 'center'
					},
					getContentAnchorEl: null
				}}
				className	= {className}
				renderValue	= {o => {
					let p = plans.find(p => p.code === o)
					return p ? p.name : ''
				}}
				data-test-id = 'select-plan-dropdown'
			>
				{plans.map(p =>
					<MenuItem
						key		= {p.name}
						value	= {p.code}
					>
						<span>{p.name} </span>
						{(p.code === this.props.plan) ? <CheckmarkIcon className={classes.selectedCheckmark}/> : null}
					</MenuItem>
				)}
			</Select>
		)
	}

	onPlanChange = event => {
		this.setState({planChanged:true})
		this.props.updatePlan(event.target.value)
	}
	
	onSaveSettingsClick = () => {
		if (!this.state.planChanged) this.saveCompanySetings()
		else this.setState({isSaveCompanySettingsModalShown: true})
	}

	saveCompanySetings = async () => {

		this.setState({isSaveCompanySettingsModalShown: false})

		// TODO: check if dirty and do validation?
		const { domainEntry, businessNameEntry, plan, isMeetingsEnabled } = this.props

		this.setState({domainStateErrorText: '', businessNameStateErrorText: ''})

		if (!this.props.businessNameEntry || this.props.businessNameEntry.replace(' ', '') === '') {
			this.setState({businessNameStateErrorText: 'Business Name can not be empty'})
			return
		}

		if (!this.props.domainEntry || this.props.domainEntry.replace(' ', '') === '') {
			this.setState({domainStateErrorText: 'Url can not be empty'})
			return
		}

		if (!this.props.plan) {
			this.setState({planErrorText: 'Select a Plan'})
			return
		}

		//update company info
		this.props.setAddingUser(true)
		try {
			if (!isMeetingsEnabled) {
				let response = await API.enableConfig(true, this.props.domainEntry, this.props.businessNameEntry, plan)
				let error = false
				if (this.checkResponseError(response)) error = true
				if (response && response.enabled) {
					this.props.setMeetingsEnabled(true)
				} else {
					this.props.setMeetingsEnabled(false)
					this.setState({domainStateErrorText: 'url is already taken'}) // this a g
					error = true
				}
				if (error) {
					this.checkResponseError(response)
					this.props.setAddingUser(false)
					return
				}
			}
			// now update any plan information and domain name changes
			let res = await API.updateConfig(true, domainEntry, businessNameEntry, plan)
			console.log(res)
			if (res && res.errors && res.errors.url === 'duplicate') {
				this.props.setAddingUser(false)
				return this.setState({domainStateErrorText: 'Url already exists'})
			}
			if (res) {
				this.setState({domain: res.domain})
				this.props.updateBusinessNameEntry(res.business)
				this.props.updatePlan(res.plan_code)
			}
		} catch(err) {
			console.log(err)
			console.error(err)
		}
		this.props.setAddingUser(false)

	}
	
	renderAddHosts = () => {
		const { classes } = this.props
		return (
			<div className={classes.section}>
				<div className={classes.sectionHeader}>Add Hosts</div>
				{/* add meetings user form */}
				<div className={classes.fieldsWrapper} style={{marginBottom: 50}}>
					<TextField
						style			= {{width: 350}}
						error			= {Boolean(this.state.nameErrorText)}
						helperText		= {this.state.nameErrorText}
						label			= 'Name'
						placeholder		= 'Name'
						onChange		= {this.onNameChange}
						value			= {this.state.name}
						disabled		= {this.props.addingUser}
						InputLabelProps	= {{className: classes.inputLabel, shrink: true}}
						style			= {{width: 215}}
					/>
					<TextField
						error			= {Boolean(this.state.emailErrorText)}
						helperText		= {this.state.emailErrorText}
						id				= 'standard-basic'
						label			= 'Email'
						placeholder		= 'Email'
						onChange		= {this.onEmailChange}
						value			= {this.state.email}
						disabled		= {this.props.addingUser}
						InputLabelProps	= {{className: classes.inputLabel, shrink: true}}
						style			= {{width: 270}}
					/>
					<FormControl
						error		= {Boolean(this.state.extensionErrorText)}
						disabled	= {this.props.addingUser}
						style		= {{width: 210}}
					>
						{!this.state.extension ? <div className={classes.selectPlaceholder}>Associated Extension</div> : null}
						<InputLabel shrink={true} id='demo-simple-select-label' className={classes.inputLabel}>Associated Extension</InputLabel>
						{this.renderExtensions()}
						<FormHelperText>{this.state.extensionErrorText}</FormHelperText>
					</FormControl>
					<PDCButton
						variant		= 'new-primary'
						onClick		= {this.onInviteHostClick}
						disabled	= {this.props.addingUser}
						className	= {classes.actionButton}
					>Send invite</PDCButton>
				</div>
				{this.state.responseError !== '' ? this.renderResponseErrorMessage() : ''}
			</div>
		)
	}

	onEmailChange = event => this.setState({email: event.target.value})
	onNameChange = event => this.setState({name: event.target.value})
	checkResponseError = (response) => {
		if(response.error && response.error.errors && response.error.errors) {
			let errors = ''
			for (let error in response.error.errors) {
				errors += `${response.error.errors[error]}\n`
			}
			this.setState({responseError: errors})
			return true
		}
		return false

	}
	onInviteHostClick = async () => {
		if (this.state.extensionErrorText || this.state.emailErrorText || this.state.responseError || this.state.nameErrorText)
			this.setState({extensionErrorText: '', emailErrorText: '', responseError: '', nameErrorText: ''})

		if (!this.state.extension) {
			this.setState({extensionErrorText: 'Select an Extension'})
			return
		}

		if (this.props.users && this.props.users.find(user => user.voip_phone_id === this.state.extension)) {
			this.setState({ extensionErrorText: 'Extensions is already assigned a users' })
			return
		}

		if (!this.state.name) {
			this.setState({nameErrorText: 'Enter a name'})
			return
		}

		if (this.props.users && this.props.users.find(user => user.email === this.state.email)) {
			this.setState({emailErrorText: 'Email address has already been used'})
			return
		}

		if (!this.emailIsValid(this.state.email)) {
			this.setState({emailErrorText: 'Enter a valid email address'})
			return
		}

		this.props.setAddingUser(true)
		let codes ={
			MEETINGS_BASE:	19091,
			MEETINGS_PLUS:	19092,
			MEETINGS_PRO:	19093
		}
		let planCode = codes[this.props.plan]
		let response = await API.addUser(this.state.name, this.state.email, this.state.extension, planCode)
		console.log(response)
		if (response.error && response.error.errors && response.error.errors.users_limit) {
			this.setState({
				responseError: 'To add more than 5 users, please contact our support team at support@phone.com, or by phone at (800) 998-7087, or use the chat below.',
			})
		} else if (this.checkResponseError(response)){
			// pass, error occured
		} else {
			let users = this.props.users
			users.push({
				name:			response.name,
				email:			response.email,
				voip_phone_id:	response.voip_phone_id,
				access_code:	response.access_code
			})
			this.setState({
				name:			'',
				email:			'',
				extension:		'',
				snackBarOpen:	true
			})
			this.props.updateUsers(users)
		}
		this.props.setAddingUser(false)
	}

	emailIsValid = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)

	renderResponseErrorMessage = () => {
		const { classes } = this.props
		return (
			<div className={classes.responseErrorMessage}>
				<span>{this.state.responseError}</span>
			</div>
		)
	}

	renderExtensions = () => {
		const { classes } = this.props
		return (
			<Select
				value		= {this.state.extension}
				onChange	= {this.handleExtensionChange}
				style		= {{width: 210}}
				MenuProps	= {{
					classes: {list: classes.dropdownList},
					anchorOrigin: {
						vertical: 'bottom',
						horizontal: 'center'
					},
					transformOrigin: {
						vertical: 'top',
						horizontal: 'center'
					},
					getContentAnchorEl: null
				}}
				renderValue	= {item => {
					let ext = this.props.extensions.find(e => e.extension_id === item)
					return ext ? `${ext.extension}: ${ext.extension_name}` : ''
				}}
			>
				{this.props.extensions.map(item =>
					<MenuItem
						key		= {item.extension_id}
						value	= {item.extension_id}
					>
						<span>{item.extension}: {item.extension_name}</span>
						{(item.extension_id === this.state.extension) ?
							<CheckmarkIcon className={classes.selectedCheckmark}/>
						: null}
					</MenuItem>
				)}
			</Select>
		)
	}

	handleExtensionChange = event => {
		let extension = event.target.value
		this.setState({extension})
	}
	
	renderCurrentHosts = () => {
		const { classes } = this.props
		return (
			<div className={classes.section}>
				<div className={classes.sectionHeader}>Current Hosts</div>
				{(!this.props.users || !this.props.users.length) ?
					this.props.addingUser ? <div className={classes.spinnerStyle}><Spinner/></div>
						: 'No users added. Please add users above to start making video meetings.'
				:
					<div style={{width: '100%'}}>
						<div className={classes.tableHeaderRow}>
							<div className={`${classes.tableHeaderStyle} ${classes.userStyle}`}>User</div>
							<div className={`${classes.tableHeaderStyle} ${classes.extStyle}`}>Associated Extension</div>
							<div className={`${classes.tableHeaderStyle} ${classes.hostStyle}`}>Bridge</div>
							<div className={`${classes.tableHeaderStyle} ${classes.actionsStyle}`}/>
						</div>
						{this.props.users.map(user =>
							<div
								key			= {user.voip_phone_id}
								className	= {classes.rowStyle}
								valign		= 'bottom'
							>
								<div className={`${classes.cellStyle} ${classes.userStyle}`}>
									<span className='user-name'>{user.name}</span>
									<span className='user-email'>{user.email}</span>
								</div>
								<div className={`${classes.cellStyle} ${classes.extStyle}`}>
									{this.props.mappedExtensions[user.voip_phone_id] ?
										this.props.mappedExtensions[user.voip_phone_id].extension : 'extension not found'
									}
								</div>
								<div className={`${classes.cellStyle} ${classes.hostStyle}`}>{user.access_code}</div>
								<div className={classes.actionsStyle}>
									{/* <MeetingsDefaultArrowTooltip
										title		= 'Resend invite'
										placement	= 'top'
									>
										<div><MeetingsMessageIcon className={classes.actionIconStyle}/></div>
									</MeetingsDefaultArrowTooltip> */}
									
									<div>
										<DeleteIcon
											hint		= {'Delete Host'}
											className	= {classes.actionIconStyle}
											disabled	= {this.props.addingUser}
											onClick		= {() => this.onDeleteUserClick(user)}
										/>
									</div>
								</div>
							</div>
						)}
					</div>
				}
			</div>
		)
	}

	onDeleteUserClick = userToDelete => {
		this.setIsConfirmDeleteHostModalShown(true)
		this.setState({userToDelete})
	}

	setIsConfirmDeleteHostModalShown = isConfirmDeleteHostModalShown => this.setState({isConfirmDeleteHostModalShown})

	handleSnackbarClose = () => this.setState({snackBarOpen: false})

	removeUser = async () => {
		let user = this.state.userToDelete
		this.props.setAddingUser(true)
		let response = await API.removeUser(user.voip_phone_id)
		if (response && response.deleted_at) {
			let users = this.props.users
			for (let i = users.length - 1; i >= 0; i--) {
				if (users[i].voip_phone_id === user.voip_phone_id) {
					users.splice(i, 1)
					this.props.updateUsers(users)
				}
			}
		}
		this.props.setAddingUser(false)
	}

	resetCancelServiceStates = () => this.setState({isCancelServiceModalShown: false, cancelServiceReportMessage: ''})

	onCancelServiceConfirmed = async () => {
		this.setState({processingAction: true})
		await API.disableConfig(this.state.cancelServiceReportMessage)
		this.setState({processingAction: false})
		this.resetCancelServiceStates()
		this.props.setMeetingsEnabled(false)
		this.props.changeDomainEntry('')
		this.props.updateBusinessNameEntry('')
	}

	onCancelServiceReportMessageChange = event => {
		let cancelServiceReportMessage = event.target.value
		this.setState({cancelServiceReportMessage})
	}

	renderCancelServiceModalContent = () => {
		const { classes } = this.props
		return (
			<div className={classes.cancelServiceModalContent}>
				<div>Are you sure you want to cancel your video meeting service? All users will lose access to their video bridges.</div>
				<div>This action cannot be undone.</div>
				<div className='please-message'>Please take a moment to tell us why you’re cancelling:</div>
				<textarea
					value		= {this.state.cancelServiceReportMessage}
					onChange	= {this.onCancelServiceReportMessageChange}
				/>
			</div>
		)
	}

	render() {
		const { classes } = this.props
		return (
			<div>
				{this.state.processingAction ? <div className={classes.processingActionSpinnerWrapper}><Spinner/></div> : null}

				{this.renderAddUsersTitle()}
				{this.renderCompanySettings()}
				
				{this.props.isMeetingsEnabled ? this.renderAddHosts() : ''}
				{this.props.isMeetingsEnabled ? this.renderCurrentHosts() : ''}
				{this.props.isMeetingsEnabled ?
					<PDCButton
						variant		= 'new-primary'
						color		= 'danger'
						onClick		= {() => this.setState({isCancelServiceModalShown: true})}
						disabled	= {this.props.addingUser}
						className	= {classes.actionButton}
					>Cancel Service</PDCButton>
				: null}

				<Snackbar
					open				= {this.state.snackBarOpen}
					onClose				= {this.handleSnackbarClose}
					TransitionComponent	= {Slide}
					message				= 'Invite sent! Make sure they accept the invite so they may begin enjoying safe and secure online meetings.'
					ContentProps		= {{classes: {root: classes.snackbarDiv, message: classes.snackbarMessage}}}
					className			= {classes.snackbarWrapper}
				/>

				<ConfirmDeleteModal
					itemType					= 'recording'
					isShown						= {this.state.isConfirmDeleteHostModalShown}
					acknowledgedTitle			= 'Delete host?'
					notAcknowledgedTitle		= 'Delete host?'
					acknowledgedMainContent		= 'Are you sure you want to delete this user? This action cannot be undone.'
					notAcknowledgedMainContent	= 'Are you sure you want to delete this user? This action cannot be undone.'
					onClose						= {() => this.setIsConfirmDeleteHostModalShown(false)}
					onDelete					= {this.removeUser}
					newButtonDesigns			= {true} // This is temporary prop until we decide what we'll do with the colors
					size						= {'size500'}
				/>

				<ConfirmModal
					isShown			= {this.state.isSaveCompanySettingsModalShown}
					title			= 'Change Plan?'
					content			= {<div>Changing plans will change the plan for all your users; additional costs may apply.</div>}
					noButtonText	= 'Cancel'
					yesButtonText	= 'Change plan'
					onReject		= {() => this.setState({isSaveCompanySettingsModalShown: false})}
					onConfirm		= {this.saveCompanySetings}
					size			= 'size2' // size440
				/>

				<ConfirmModal
					isShown			= {this.state.isCancelServiceModalShown}
					title			= 'Cancel service?'
					content			= {this.renderCancelServiceModalContent()}
					noButtonText	= 'Not now'
					yesButtonText	= 'Cancel service'
					yesButtonColor	= 'attention'
					onReject		= {this.resetCancelServiceStates}
					onConfirm		= {this.onCancelServiceConfirmed}
					size			= 'size550'
				/>
			</div>
		)
	}
}

export default withStyles(styles)(AddUsers)